import { UIText2 } from '@cian/ui-kit';
import { Button } from '@cian/ui-kit/button';
import { Input } from '@cian/ui-kit/input';
import { ModalWindow } from '@cian/ui-kit/modal';
import { TooltipDesktop } from '@cian/ui-kit/tooltip';
import * as React from 'react';

import * as styles from './styles.css';
// eslint-disable-next-line import/no-cycle
import { EDemandTrapScreen } from '../../../containers/DemandActionContainer';

interface INeedCodeProps {
  onClose(): void;
  onSubmit(smsCode: string): void;
  onRetry(): void;
  phone: string;
  isLoading: boolean;
  screen: EDemandTrapScreen;
  isMobile: boolean;
}

const RETRY_DELAY = 60;

export function NeedCode({ onClose, onSubmit, onRetry, phone, isLoading, screen, isMobile }: INeedCodeProps) {
  const [smsCode, setSmsCode] = React.useState<string>('');
  const [retryDelay, setRetryDelay] = React.useState<number>(RETRY_DELAY);
  const [isError, setIsError] = React.useState<boolean>(screen === EDemandTrapScreen.SmsCodeError);

  const isRetryDelayActive = retryDelay > 0;

  React.useEffect(() => {
    if (screen === EDemandTrapScreen.SmsCodeError) {
      setIsError(true);
    }
  }, [screen]);

  React.useEffect(() => {
    if (isRetryDelayActive) {
      const interval = setInterval(() => setRetryDelay(retryDelay => retryDelay - 1), 1000);

      return () => clearInterval(interval);
    }

    return undefined;
  }, [isRetryDelayActive]);

  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, value: string) => {
      if (value.length > 20) {
        return;
      }

      if (isError) {
        setIsError(false);
      }

      setSmsCode(value);
    },
    [isError, setSmsCode],
  );

  const handleSubmit = React.useCallback(() => {
    if (!smsCode) {
      setIsError(true);

      return;
    }

    onSubmit(smsCode);
  }, [smsCode, setIsError, onSubmit]);

  const handleRetry = React.useCallback(() => {
    onRetry();
    setRetryDelay(RETRY_DELAY);
  }, [onRetry]);

  return (
    <ModalWindow open={true} onClose={onClose} maxWidth={448} title="Подтверждение SMS-кодом">
      <div className={styles['container']}>
        <div className={styles['text']}>
          <UIText2>На номер {phone} выслан код для подтверждения</UIText2>
        </div>
        <div className={styles['input-row']}>
          <div className={styles['code']}>
            <TooltipDesktop open={isError} title="Неверный код">
              <Input value={smsCode} onChange={handleChange} invalid={isError} placeholder="SMS-код" size="M" />
            </TooltipDesktop>
          </div>
          <div className={styles['retry']}>
            {isRetryDelayActive ? (
              <UIText2>Отправить повторно через {retryDelay} c</UIText2>
            ) : (
              <a href="#" onClick={handleRetry} className={styles['retry-link']}>
                Отправить еще раз
              </a>
            )}
          </div>
        </div>
        <div className={styles['footer']}>
          <Button loading={isLoading} onClick={handleSubmit} size={isMobile ? 'M' : 'XS'}>
            Подтвердить
          </Button>
        </div>
      </div>
    </ModalWindow>
  );
}
